import { Center, Box, Flex } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import adBg from "../../assets/LBPortal_Graphic_AdBG.webp";
import Btn from "../UI/Btn";

export default function LandscapeAd({
  slot = "4158594940",
  adtest,                 
  reserveMinH = 90,       
  compact = true,         
}) {
  const insRef = useRef(null);
  const pushedRef = useRef(false);
  const [showFallback, setShowFallback] = useState(false);

  const isLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");

  useEffect(() => {
    const el = insRef.current;
    if (!el) return;

    const ro = new ResizeObserver(([entry]) => {
      const w = entry.contentRect.width;
      if (w > 0 && !pushedRef.current) {
        pushedRef.current = true;
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch {}

        const t = setTimeout(() => {
          const loaded = !!el.querySelector("iframe");
          console.log("[AdSense]", loaded ? "iframe loaded" : "no iframe (test/blocked/no-fill)");
          if (!loaded) setShowFallback(true);
        }, 2500);
        el.__adsenseTimeout__ = t;
      }
    });

    ro.observe(el);
    return () => {
      ro.disconnect();
      if (el?.__adsenseTimeout__) clearTimeout(el.__adsenseTimeout__);
    };
  }, []);

  const testAttr = (adtest ?? isLocal) ? { "data-adtest": "on" } : {};

  if (showFallback) {
    return (
      <Center mt={compact ? "8px" : "16px"} mb={compact ? "12px" : "24px"} mx="auto" w="100%">
        <Box
          w="100%"
          minH={`${reserveMinH}px`}
          borderRadius="xl"
          borderBottomLeftRadius="xl"      
          borderBottomRightRadius="xl"     
          boxShadow="none"
          overflow="hidden"
          data-ad="landscape"
        >
          <Flex
            w="100%"
            h="100%"
            borderRadius="inherit"          
            bgImage={adBg}
            bgSize="cover"
            bgPos="center"
            align="center"
            justify="space-between"
            px={{ base: 4, md: 8 }}
            py={{ base: 4, md: 6 }}
            gap={4}
            fontWeight="bold"
          >
            <Box
              fontSize={{ base: "md", md: "xl" }}
              textAlign="left"
              textShadow="0 0 2px white, 0 0 2px white, 0 0 2px white, 0 0 2px white"
            >
              We do games &amp; gamification.
            </Box>
            <Link to="/contact">
              <Btn size="sm">Contact us!</Btn>
            </Link>
          </Flex>
        </Box>
      </Center>
    );
  }

  return (
    <Center mt={compact ? "8px" : "16px"} mb={compact ? "12px" : "24px"} mx="auto" w="100%">
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", width: "100%", minHeight: `${reserveMinH}px` }}
        data-ad-client="ca-pub-2039872576922787"
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
        {...testAttr}
      />
    </Center>
  );
}
